module.exports = __webpack_public_path__ + "static/media/marseille-12.255c39e5.jpg";